import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
 * 共通：要素切り替えボタンコンポーネント（主にON/OFFのトグル挙動用）
 * @param props
 * @constructor
 */
export const ToggleIconButtonBase = (props) => {
    const { boolState, className = '', disabled, falseIconClassName = '', falseIconColor = 'base', falseIconComponent: FalseIcon, onClick, size, trueIconClassName = '', trueIconColor, trueIconComponent: TrueIcon, type, value, } = props;
    /* eslint-disable react/button-has-type */
    return (_jsx("button", Object.assign({ className: className, disabled: disabled, onClick: onClick, type: type, value: value }, { children: boolState ? (_jsx(TrueIcon, { className: trueIconClassName, color: trueIconColor, size: size })) : (_jsx(FalseIcon, { className: falseIconClassName, color: falseIconColor, size: size })) })));
};
